const ACWR_MAX = 5;
const CLIP_START_OFFSET = -5;
const GAME_CLIP_END_OFFSET = 10;
const PRACTICE_CLIP_END_OFFSET = 5;
const SHIFT_VIDEO_ADJUSTMENT_RANGE_SECONDS = 30;

export {
  ACWR_MAX,
  CLIP_START_OFFSET,
  GAME_CLIP_END_OFFSET,
  PRACTICE_CLIP_END_OFFSET,
  SHIFT_VIDEO_ADJUSTMENT_RANGE_SECONDS,
};
